import React, { Component } from "react";
import { Helmet } from "react-helmet";

// UI
import { Col, Container, Header, Row } from "../../../ui";

class ReportsPage extends Component {
  state = {
    title: "Отчётность"
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>

        <Container fluid>
          <Header size={3} margin="no-top">
            {this.state.title}
          </Header>

          <Row flexColumn>
            <Col padding={"no-top"}>
              <a
                href={process.env.PUBLIC_URL + "/reports/report_result.pdf"}
                target={"_blank"}
              >
                Готовой отчёт
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ReportsPage;
